/**
 * Vuex "analytics" module.
 *
 * Aggregates the analytics/metrics-tracking store slice: state (store.js),
 * actions (operations.js), getters (selectors.js), and mutations
 * (updates.js). Currently only exposes the sendTrackPage action for
 * reporting page views to the metrics API; state/getters/mutations are
 * placeholders for future analytics state.
 */
import actions from './operations';
import getters from './selectors';
import mutations from './updates';
import state from './store';

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
